import { each, has, isNumber, toInteger } from 'lodash';
import dayjs from '../lib/dayjs';
import { ActivityTypeEnum, DiscountTypeEnum, OffTypeEnum, ProductTypeEnum, UsePromoCodeStatusEnum } from '../enum';
import { findActivityProduct, toFixed } from '../lib/utils';
/**
 * 单品优惠计算和比较
 * @param opt
 * @returns
 */
export default function calculateFee(opt) {
    var _a, _b, _c, _d, _e, _f;
    const { activity, product, itemMap, usePromoCodeStatusMap, isUseGroupBuy, activityPurchaseLimitMap } = opt;
    if (has(activity.extra, 'purchaseLimit') && !activityPurchaseLimitMap[activity.activityId]) {
        activityPurchaseLimitMap[activity.activityId] = 0;
    }
    let { usePromoCodeStatus } = opt;
    const nowTime = product.addTime;
    if (activity.startTime > nowTime || activity.endTime < nowTime) {
        return usePromoCodeStatus;
    }
    if (!activity.isAllTime) {
        const nowHourTime = dayjs(nowTime).format('HH:mm');
        const nowDay = dayjs(nowTime).day();
        const nowDate = dayjs(nowTime).date();
        let isPushed = false;
        if (activity.timeRangeType === 'month') {
            if ((_a = activity.days) === null || _a === void 0 ? void 0 : _a.includes(nowDate)) {
                isPushed = true;
            }
        }
        else {
            each(activity.timeRanges, (timeRange) => {
                if (timeRange.isOpen && timeRange.weekDay === nowDay) {
                    each(timeRange.ranges, (range) => {
                        if (range.startTime <= nowHourTime && range.endTime >= nowHourTime) {
                            isPushed = true;
                            return;
                        }
                    });
                }
            });
        }
        if (!isPushed) {
            return usePromoCodeStatus;
        }
    }
    let off = 0; // 优惠金额
    let offTip = '';
    let productPrice = product.price;
    // 特价活动目前不包含加料优惠
    if (activity.type === ActivityTypeEnum.SpecialOffer) {
        activity.discountType = DiscountTypeEnum.SpecialOffer;
        activity.isIncludeModifier = false;
    }
    if (activity.isIncludeModifier) {
        productPrice = product.productAndModifierPrice;
    }
    if (productPrice <= 0) {
        return usePromoCodeStatus;
    }
    if (((_b = activity.extra) === null || _b === void 0 ? void 0 : _b.purchaseLimit) &&
        ((_c = activity.extra) === null || _c === void 0 ? void 0 : _c.purchaseLimit) > 0 &&
        ((_d = activity.extra) === null || _d === void 0 ? void 0 : _d.purchaseLimit) <= activityPurchaseLimitMap[activity.activityId] &&
        opt.isOrder) {
        return usePromoCodeStatus;
    }
    if (activity.discountType === DiscountTypeEnum.DiscountFee && product.type !== ProductTypeEnum.Modifier) {
        off = activity.discountValue;
        if (off > productPrice) {
            off = productPrice;
        }
    }
    else if (activity.discountType === DiscountTypeEnum.DiscountRate) {
        if (product.type === ProductTypeEnum.Modifier && !activity.isIncludeModifier) {
            off = 0;
        }
        else {
            off = toFixed(productPrice * (1 - activity.discountValue));
        }
    }
    else if (activity.discountType === DiscountTypeEnum.SpecialOffer && product.type !== ProductTypeEnum.Modifier) {
        // 特价
        const findProduct = findActivityProduct(activity.productMap, product);
        off = 0;
        if (findProduct && isNumber(findProduct.activityPrice) && findProduct.activityPrice < productPrice) {
            off = toFixed(productPrice - findProduct.activityPrice);
        }
    }
    offTip = activity.activityName;
    let productCnt = product.cnt || 1;
    if (((_e = activity.extra) === null || _e === void 0 ? void 0 : _e.purchaseLimit) && opt.isOrder) {
        const remainCnt = toInteger((_f = activity.extra) === null || _f === void 0 ? void 0 : _f.purchaseLimit) - activityPurchaseLimitMap[activity.activityId];
        if (remainCnt < productCnt) {
            productCnt = remainCnt;
        }
    }
    off = toFixed(off * productCnt);
    let id = product.pk || product.productNo + '_' + product.scaleNo;
    if (product.type === ProductTypeEnum.Modifier) {
        id = product.productNo + '_' + product.modifierGroupNo + '_' + product.modifierNo;
    }
    if (itemMap[id]) {
        // 拼团特殊处理
        if (off > (itemMap[id].off || 0) &&
            ((isUseGroupBuy && activity.type === ActivityTypeEnum.GroupBuy) || activity.type !== ActivityTypeEnum.GroupBuy)) {
            itemMap[id].off = off;
            itemMap[id].offTip = offTip;
            itemMap[id].offId = activity.activityId;
            itemMap[id].activity = {
                type: activity.type,
                activityName: activity.activityName,
                activityId: activity.activityId,
            };
            itemMap[id].offType = OffTypeEnum.Activity;
            itemMap[id].isIncludeModifier = activity.isIncludeModifier || false;
            activityPurchaseLimitMap[activity.activityId] += productCnt;
        }
    }
    else {
        if ((isUseGroupBuy && activity.type === ActivityTypeEnum.GroupBuy) || activity.type !== ActivityTypeEnum.GroupBuy) {
            itemMap[id] = Object.assign(Object.assign({}, product), { off,
                offTip, offId: activity.activityId, activity, offType: OffTypeEnum.Activity, isIncludeModifier: activity.isIncludeModifier || false });
            activityPurchaseLimitMap[activity.activityId] += productCnt;
        }
    }
    if (activity.type === ActivityTypeEnum.GroupBuy) {
        const findProduct = findActivityProduct(activity.productMap, product);
        if (findProduct) {
            itemMap[id].groupBuyPrice = findProduct.activityPrice;
        }
    }
    if (activity.promoCode) {
        usePromoCodeStatus = UsePromoCodeStatusEnum.Effective;
        itemMap[id].offType = OffTypeEnum.PromoCode;
    }
    usePromoCodeStatusMap[id] = usePromoCodeStatus;
    return usePromoCodeStatus;
}
//# sourceMappingURL=calCulateFee.js.map